import React, { useState } from 'react'
import './styles/component-styles.scss'
import { EyeSlash, Pencil, Eye, CurrencyCircleDollar } from '@phosphor-icons/react'
import { ClassesLateFee, PriceUnit } from 'types/Classes/Classes'
import { capitalizeFirstLetter } from 'helper/utility'
import { Dropdown } from 'antd'
import LateFee from '../Modals/LateFee/LateFee'
import { classesEventStore } from 'state/classes/classesStore'
import ButtonSpinner from 'components/global/ButtonSpinner'

interface LateFeeCompProps {
  details: ClassesLateFee
}

const LateFeeComp: React.FC<LateFeeCompProps> = ({ details }) => {
  const classesData = classesEventStore(store => store.classesData) as any
  const setClassesData = classesEventStore(store => store.setClassesData)

  const [openLateFee, setOpenLateFee] = useState<boolean>(false)

  const handleMenuClick = (operation: 'edit' | 'visibility') => {
    if (operation === 'edit') {
      setOpenLateFee(true)
      return
    }
  }

  const getPriceUnitText = (unit: PriceUnit) => {
    switch (unit) {
      case PriceUnit.day:
        return 'per day'
      case PriceUnit.hour:
        return 'per hour'
      case PriceUnit.minute:
        return 'per minute'
      default:
        return 'per day'
    }
  }

  const manageOptions = [
    {
      key: 'edit',
      label: (
        <div
          className="flex gap-16px align-center"
          onClick={() => handleMenuClick('edit')}
        >
          <Pencil size={20} color="#000" />
          <p className="text-14 w-500">Edit late fee</p>
        </div>
      ),
    },
    // {
    //   key: 'visibility',
    //   label: (
    //     <div
    //       className="flex gap-16px align-center"
    //       onClick={() => handleMenuClick('visibility')}
    //     >
    //       <EyeSlash size={20} color="#000" />
    //       <p className="text-14 w-500">Make Disable</p>
    //     </div>
    //   ),
    // },
  ]

  return (
    <>
      <div
        className="ticket-main-cont"
        style={{ backgroundColor: `#${details.color || '000000'}` }}
      >
        <div className="content">
          <div className="flex justify-between align-center">
            <h2 className="text-18 w-600">
              {capitalizeFirstLetter(details.title)}
            </h2>
          
          </div>

          <p className="text-14 w-600 mt-15px">{`$${details.price.toFixed(2)} ${getPriceUnitText(details.priceUnit)}`}</p>

          <Dropdown
            menu={{ items: manageOptions }}
            placement="bottomLeft"
            arrow={false}
            className="ml-20px mr-10px"
            overlayStyle={{ width: '300px' }}
            trigger={['click']}
          >
            <button className="ticket-button pointer">Manage</button>
          </Dropdown>
        </div>
        <div className="dull-color"></div>
      </div>

      {openLateFee && (
        <LateFee
          modalOpen={openLateFee}
          modalClose={setOpenLateFee}
          data={details}
        />
      )}
    </>
  )
}

export default LateFeeComp
